import React from "react";
import BeforeAfter from "./BeforeAfter";
import Reveal from "./Reveal";
import { EXAMPLE_ORIGINAL, STYLES } from "../mock";
import { MoveHorizontal } from "lucide-react";

export default function ExamplePhoto() {
  // Use the watercolor or illustration style as the "after"
  const afterImg =
    STYLES.find((s) => s.id === "acuarela")?.image ||
    STYLES.find((s) => s.id === "ilustracion")?.image;

  return (
    <section id="ejemplo" className="py-20 md:py-32 bg-[#f5f1e8]">
      <div className="max-w-5xl mx-auto px-6">
        <Reveal className="text-center">
          <div className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-[#b59557] mb-4">
            Ejemplo real
          </div>
          <h2 className="font-serif font-medium text-[#1a1816] text-3xl md:text-5xl leading-tight">
            De foto a{" "}
            <span className="italic text-[#b59557] font-light">obra de arte</span>
          </h2>
          <p className="mt-4 text-[#4a4136] text-sm md:text-base max-w-xl mx-auto">
            Arrastra el deslizador para ver la transformación. Convertimos tus fotos en retratos únicos sobre madera blanca.
          </p>
        </Reveal>

        <Reveal delay={1}>
          <div className="mt-12 md:mt-16 max-w-2xl mx-auto">
            <BeforeAfter
              before={EXAMPLE_ORIGINAL}
              after={afterImg}
              beforeLabel="Antes"
              afterLabel="Después"
              aspectRatio="1 / 1"
            />
          </div>
        </Reveal>

        <Reveal delay={2}>
          <div className="mt-6 flex items-center justify-center gap-2 text-xs md:text-sm text-[#7a6a48]">
            <MoveHorizontal className="h-4 w-4 text-[#b59557]" />
            Arrastra · pulsa · usa las flechas del teclado
          </div>
        </Reveal>
      </div>
    </section>
  );
}
